export class CostReviewElectricalSubcontractors {
  subcontractorTermsAndConditions!: number;
  vendorPricingConfirmed!: number;
  additionalMaterialPriceAndDeliveryConfirmed!: number;
}
